
import type { ActionType, ProColumns } from '@ant-design/pro-components';
import {
  ProTable
} from '@ant-design/pro-components';
import { Modal } from 'antd';
import { useRef } from 'react' 
type ProSelectTableProps = {
  dataSource: (value: any) => Promise<any>
  columns: ProColumns []
  open: boolean
  onCancel: (values?: any) => void;
  width?: number;
  fieldProps?: any;
  selectRow?: any;
  setSelectRow?: any;
}
export const ProSelectTable = (props: ProSelectTableProps) => {
  const actionRef = useRef<ActionType>();
  
  return (
    <Modal
      width={props.width || 600}
      open={props.open}
      onCancel={props.onCancel}
      closable={false}
      footer={null}
    >
      <ProTable
        {...props.fieldProps}
        rowKey={'id'}
        actionRef={actionRef}
        columns={props.columns}
        rowSelection={{
          selectedRowKeys: props.selectRow,
          onChange: (_, selectedRows) => {
            const ids = selectedRows.map(item => item.id)
            props.setSelectRow(ids)
          },
        }}
        request={async (params: any) => {
          params.pageNum = params.current
          delete params.current
          const res = await props.dataSource(params)
          return {
            data: res?.list,
            total: res?.total,
            success: true
          }
        }}
      >
        
      </ProTable>
    </Modal>
  )
}